var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignoutV01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09895 1C4.0443 1 4 1.0443 4 1.09895V23.2135C4 23.2682 4.0443 23.3125 4.09895 23.3125H13.452C13.7515 23.3125 13.9943 23.0697 13.9943 22.7703C13.9943 22.4708 13.7515 22.228 13.452 22.228H6.03133H5.03133V21.228V3.08376V2.08376H6.03133H13.4524C13.7516 2.08376 13.9943 1.84115 13.9943 1.54188C13.9943 1.24261 13.7516 1 13.4524 1H4.09895ZM19.026 11.6147H17.6458H10.7428C10.4437 11.6147 10.2013 11.8572 10.2013 12.1563C10.2013 12.4553 10.4437 12.6978 10.7428 12.6978H17.6458H19.026L18.0748 13.6978L15.7049 16.1891C15.5109 16.393 15.5109 16.7132 15.7049 16.917C15.913 17.1357 16.2618 17.1357 16.4699 16.917L20.564 12.6147L20.9608 12.1978L21 12.1566L20.9605 12.1151L20.5634 11.6978L16.4699 7.39557C16.2618 7.17686 15.913 7.17685 15.7049 7.39554C15.5109 7.59938 15.5109 7.91954 15.7048 8.12342L18.0748 10.6147L19.026 11.6147Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutV01);
export default __webpack_public_path__ + "static/media/signout_v01.e321c44046b9f27059bfcf60b7865f2317f9ab1622f1d10f7cafc2b4451509a8.svg";
export { ForwardRef as ReactComponent };